import { CerbosProjectActions, CerbosProjectKind, CerbosTeamActions, CerbosTeamKind } from '@shared/cerbos-types';
import { buildAbacPrincipal, buildProjectAttributes, buildTeamAttributes } from '../abac';
import { getDecision } from '../decision';
const checkActions = async function(organization, user, actions) {
    let kind = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : CerbosProjectKind, project = arguments.length > 4 ? arguments[4] : void 0;
    var _ref;
    const isTeamResource = kind === CerbosTeamKind;
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind,
            id: isTeamResource ? organization.id : (_ref = project === null || project === void 0 ? void 0 : project.id) !== null && _ref !== void 0 ? _ref : organization.id,
            attributes: isTeamResource ? buildTeamAttributes(organization) : buildProjectAttributes(organization, project)
        },
        actions
    });
    return actions.map((action)=>decision.isAllowed(action));
};
export const canMangeConfigKey = [
    'canManageProject',
    CerbosProjectActions.UPDATE_PROJECT,
    CerbosProjectActions.UPDATE_PROJECT_NAME,
    CerbosProjectActions.UPDATE_PROJECT_SETTINGS,
    CerbosProjectActions.DELETE_PROJECT,
    CerbosProjectActions.MANAGE_CONTRIBUTOR,
    CerbosProjectActions.MANAGE_ALL_CONTRIBUTOR
].join('/');
export const canMangeContributorConfigKey = [
    'canManageProject',
    CerbosProjectActions.MANAGE_CONTRIBUTOR
].join('/');
export const canMangeAllContributorConfigKey = [
    'canManageProject',
    CerbosProjectActions.MANAGE_ALL_CONTRIBUTOR
].join('/');
export const getCanManageProjConfig = async (organization, user, project)=>{
    const [updateProject, updateProjectName, updateProjectSettings, deleteProject, manageContributor, manageAllContributor] = await checkActions(organization, user, [
        CerbosProjectActions.UPDATE_PROJECT,
        CerbosProjectActions.UPDATE_PROJECT_NAME,
        CerbosProjectActions.UPDATE_PROJECT_SETTINGS,
        CerbosProjectActions.DELETE_PROJECT,
        CerbosProjectActions.MANAGE_CONTRIBUTOR,
        CerbosProjectActions.MANAGE_ALL_CONTRIBUTOR
    ], CerbosProjectKind, project);
    return {
        updateProject: updateProject !== null && updateProject !== void 0 ? updateProject : false,
        updateProjectName: updateProjectName !== null && updateProjectName !== void 0 ? updateProjectName : false,
        updateProjectSettings: updateProjectSettings !== null && updateProjectSettings !== void 0 ? updateProjectSettings : false,
        deleteProject: deleteProject !== null && deleteProject !== void 0 ? deleteProject : false,
        manageContributor: manageContributor !== null && manageContributor !== void 0 ? manageContributor : false,
        manageAllContributor: manageAllContributor !== null && manageAllContributor !== void 0 ? manageAllContributor : false
    };
};
export const getCanManageContributorConfig = async (organization, user, project)=>{
    const [can] = await checkActions(organization, user, [
        CerbosProjectActions.MANAGE_CONTRIBUTOR
    ], CerbosProjectKind, project);
    return {
        can: can !== null && can !== void 0 ? can : false
    };
};
export const getCanManageAllContributorConfig = async (organization, user, project)=>{
    const [can] = await checkActions(organization, user, [
        CerbosProjectActions.MANAGE_ALL_CONTRIBUTOR
    ], CerbosProjectKind, project);
    return {
        can: can !== null && can !== void 0 ? can : false
    };
};
export const getCanCreateProjectTeams = async (organization, user)=>{
    const [can] = await checkActions(organization, user, [
        CerbosTeamActions.CREATE_TEAM
    ], CerbosTeamKind);
    return {
        can: can !== null && can !== void 0 ? can : false
    };
};
